export const PURPLE_AS_PER_BACKEND = "purple";
export const GREEN_AS_PER_BACKEND = "green";
export const RED_AS_PER_BACKEND = "red";
